// extracted by mini-css-extract-plugin
export var chip = "_3w-9";
export var chipLabel = "_3w-a";
export var close = "_3w-7";
export var closeIcon = "_3w-8";
export var error = "_3w-6";
export var infoTooltip = "_3w-2";
export var innerContainer = "_3w-1";
export var input = "_3w-b";
export var medium = "_3w-5";
export var outerContainer = "_3w-0";
export var small = "_3w-4";
export var xSmall = "_3w-3";